import React from 'react'
import { motion } from "framer-motion"
import { useInView } from 'react-intersection-observer'
import { useEffect } from 'react'
import { useAnimation } from 'framer-motion'

const Heading = ({ text }) => {

    // const { ref, inView } = useInView();

    // const animation = useAnimation();

    // useEffect(() => {
    //     console.log("useeffect hook", inView);
    //     if (inView) {
    //         animation.start({
    //             y: 0,
    //             opacity: 1,
    //             transition: {
    //                 ease: [0.6, 0.01, -0.05, 0.95],
    //                 duration: 1,
    //                 delay: 0.2,
    //             }
    //         });
    //     }
    //     if (!inView) {
    //         animation.start({
    //             y: -30,
    //             opacity: 0,
    //         });
    //     }
    // }, [inView]);

    return (
        <motion.h2
            className='font-syncopate font-bold text-[2rem] leading-none mx-auto mb-8 w-fit lg:w-[100%] lg:col-start-1 lg:col-end-5 border-b-[1px] border-b-line pb-6 md:mb-16'>
            {text}
        </motion.h2>
    )
}

export default Heading
